import EventDetails from "components/EventDetails/EventDetails";
import { observer } from "mobx-react";
import EventsView from "pages/EventsView/EventsView";
import React, { useEffect } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { useStore } from "store/StoreConfigs";

function ThorModule() {
    const { commonStore, filtersStore } = useStore();
    const history = useHistory();

    useEffect(() => {
        commonStore.setSelectedTab(2);
        filtersStore.setModule("Thor");
    }, []);
    return (
        <Switch>
            <Route exact path="/thor/eventDetails/:eventId">
                <EventDetails />
            </Route>
            <Route exact path="/thor">
                <EventsView />
            </Route>
            <Route path="*">{() => history.push("/thor")}</Route>
        </Switch>
    );
}
export default observer(ThorModule);
